<div class="container-fluid insight-container">
    <div class="row">
        <div class="insight-component-wrapper">
            <ng-container *ngIf="isAgentRole; else myCoaching">
                <div
                    class="insight-component-child"
                    cmpsCoachingCardRep
                ></div>
            </ng-container>
            <ng-template #myCoaching>
                <div
                    class="insight-component-child"
                    cmpsMyCoachingCard
                ></div>
            </ng-template>
            <div
                class="insight-component-child"
                cmpsMyPerformanceCard
            ></div>
            <div
                class="insight-component-child"
                cmpsMyScorecard
            ></div>
        </div>
    </div>
</div>
